import { gql } from '@apollo/client'

export const SIMPLE_ACTION_GENERATOR_FRAGMENT = gql`
  fragment SimpleActionGeneratorFragment on ActionGenerator {
    id
    title
    dueDateTime
    stores {
      id
    }
  }
`
